export default __webpack_public_path__ + "static/media/WalkwayCross.256.34b874a9.png";